import { useEffect } from "react";

export function Header(props) {
    const { label } = props;

    useEffect(() => {
        const contentTable = document.getElementsByClassName("rbc-agenda-table")?.item(1);
        const rows = contentTable.querySelectorAll("tr");
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const cells = row.querySelectorAll("td");
            if (cells.length === 2) {
                row.style.setProperty("border-color", "white", "important");
                const prevRowCell = rows[i - 1].querySelector("td");
                const newCell = document.createElement("td");
                newCell.style.setProperty("min-width", `${prevRowCell.clientWidth}px`, "important");
                newCell.style.setProperty("background-color", "white", "important");
                newCell.style.setProperty("border-color", "white", "important");
                newCell.classList.add("rbc-agenda-date-cell");
                row.insertBefore(newCell, row.firstChild);
            }
        }
    }, []);

    return label;
}

const Agenda = { Header };
export default Agenda;
